import locale from 'element-ui/lib/locale';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './language';
// import {getRequest} from '../utils/index'
import httpRequest from '@/utils/httpRequest';
// Vue.prototype.$http = httpRequest ;// ajax请求方法
Vue.use(VueI18n);

// var locales = 'en_US';
var locales = 'zh_CN';
  httpRequest.getCookie().then((data) => {
      locales = data.data.lang == "en_US" || data.data.lang == "zh_CN" || data.data.lang == "zh_HANT" ? data.data.lang : "zh_CN";
      if (data.data.location != "CN" ) {
        locales = data.data.lang == "en_US" || data.data.lang == "zh_CN" || data.data.lang == "zh_HANT" ? data.data.lang : "en_US";
      }
      i18n.locale = locales;
    }).catch((err) => {
      locales = 'zh_CN'
      i18n.locale = locales
  });

  const i18n = new VueI18n({
    locale:locales,
    messages
  })
  locale.i18n((key, value) => i18n.t(key, value))
export default i18n






// WEBPACK FOOTER //
// ./src/i18n/i18n.js